export const TIME_5000 = 10000;
